module.exports = __webpack_public_path__ + "assets/language-squares/es-419@2x-f37716929e3235bc74a9711e5779efed.jpg";